<template lang="pug">
  div.qmod-dropdown-menu-wrap
    div.qmod-dropdown-menu.ripple
      span.qmod-dropdown-title(v-on:click="triggerMenuOpen()")
        a() {{dropDown.dropdown.list[dropDown.dropdown.selected].label}}
        i.material-icons arrow_drop_down
      transition(name="qmodbounce")  
        ul.qmod-dropdown-ul(v-if="dropDown.dropdown.open")
          li.qmod-dropdown-li(v-for="(dropdown, idx) in dropDown.dropdown.list", :class="idx==dropDown.dropdown.selected ? 'qmod-active' : ''", v-on:click="triggerDropDownEvent(dropdown, idx)")
            a() {{dropdown.label}}
            i.material-icons.md-18 check
</template>

<script>
/* eslint-disable */
export default {
  name: "BaseDropdown",
  props: {
    dropDown: {
      type: Object,
      required: false,
      default: false
    }
  },
  methods: {
    triggerMenuOpen() {
      console.log(this.dropDown);
      this.dropDown.dropdown.open = !this.dropDown.dropdown.open;
    },
    triggerDropDownEvent(dropdown, idx) {
      console.log("dfdfdfdfdf");
      this.$emit("dropDownEvent", dropdown, idx);
    }
  }
};
</script>

<style lang="stylus">
.ripple
  background-position center
  transition background 0.8s
.ripple:hover
  background $qmod-dark-grey radial-gradient(circle, transparent 1%, $qmod-dark-grey 1%) center / 15000%
.ripple:active
  background-color $qmod-grey
  background-size 100%
  transition background 0s
.qmodbounce-enter-active
  animation bounce-in 0.3s
.qmodbounce-leave-active
  animation bounce-in 0.3s reverse
@keyframes bounce-in
  0%
    transform scale(0)
  50%
    transform scale(1.2)
  100%
    transform scale(1)
.qmod-dropdown-menu-wrap
  padding $qmod-padding-sm
.qmod-dropdown-menu
  min-width 180px
  border 1px solid #ececec
  position relative
  overflow visible
  background-color $qmod-grey
  cursor pointer
  border-radius 5px
  margin 0 2px
  .qmod-dropdown-title
    display flex
    align-items center
    padding 8px 5px 8px 12px
    text-transform uppercase
    border-top 0
    i
      margin-left auto
      font-size 18px
  .qmod-dropdown-ul
    max-height 280px
    overflow-y auto
    overflow-x hidden
    min-width 200px
    border-radius 2px
    z-index 1
    background-color #fff
    color #222
    list-style none
    margin 0
    margin-top 8px
    padding 8px 0
    position absolute
    width auto
    box-shadow 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12), 0 5px 5px -3px rgba(0, 0, 0, 0.2)
    .qmod-dropdown-li
      text-transform uppercase
      display flex
      align-content center
      align-items center
      white-space nowrap
      text-align left
      padding 8px 12px
      i
        padding-left 12px
        margin-left auto
        font-size 18px
        visibility hidden
      &:hover, &.qmod-active
        color #000
        background-color #eee
      &.qmod-active
        i
          visibility visible
</style>
